import React, { useEffect, useState } from 'react';
import moment from 'moment';
import {
  Button,
  Box,
  Card,
  CardContent,
  Divider,
  Modal,
  Typography
} from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';

import { cash } from 'constants/paymentMethods';

const MonthlyCCTable = (props) => {

  const columns = [
    { field: 'displayId', headerName: 'ID', flex: 1, sortable: false },
    { field: 'createdAt', headerName: 'Date', flex: 1, sortable: false },
    { field: 'amountBeforeVat', headerName: 'Amount before VAT', flex: 1, sortable: false },
    { field: 'vat', headerName: 'VAT', flex: 1, sortable: false },
    { field: 'total', headerName: 'Total Amount', flex: 1, sortable: false }
  ];

  const [cashTableData, setCashTableData] = useState([]);
  const [cardTableData, setCardTableData] = useState([]);

  useEffect(() => {
    let cashBuffer = [];
    let cardBuffer = [];

    const startDate = moment([ moment().year(), props.month ]);
    const endDate = moment([ moment().year(), props.month ]).add(1, 'month');

    while (startDate.isBefore(endDate)) {
   
      // Sales Orders
      for ( let i = 0; i < props.salesOrders.length; i++ ) {
        const currSalesOrder = props.salesOrders[i];
        for ( let j = 0; j < currSalesOrder.payments.length; j++ ) {
          if(startDate.isSame(currSalesOrder.payments[j].createdAt, 'day')) {
            const payment = currSalesOrder.payments[j];
            if(payment.paymentMethod === cash) {
              cashBuffer.push({
                displayId: payment.displayId,
                createdAt: moment(payment.createdAt).format('DD/MM/YYYY'),
                amountBeforeVat: payment.amount - payment.amountVat,
                vat: payment.amountVat,
                total: payment.amount
              });
            }
            else {
              cardBuffer.push({
                displayId: payment.displayId,
                createdAt: moment(payment.createdAt).format('DD/MM/YYYY'),
                amountBeforeVat: payment.amount - payment.amountVat,
                vat: payment.amountVat,
                total: payment.amount
              });
            }
          }
        }
      }

      startDate.add(1, 'day');
    }
    
    setCashTableData(cashBuffer);
    setCardTableData(cardBuffer);
    
  }, [props.salesOrders, props.month]);

  return (
    <Modal open={props.open}>
      <Card>
        <CardContent>
          <Box>
            <Typography
              color="textPrimary"
              variant="h5"
            >
              Month Report : {moment([ moment().year(), props.month ]).format('MMMM/YYYY')}
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              columnGap: 40,
              marginBottom: '1%'
            }}
          >
            <Typography
              color="textPrimary"
              variant="h6"
            >
              TOTAL CASH : {cashTableData.reduce((prev, curr) => prev + curr.total, 0)} AED
            </Typography>
            <Typography
              color="textPrimary"
              variant="h6"
            >
              TOTAL CARD : {cardTableData.reduce((prev, curr) => prev + curr.total, 0)} AED
            </Typography>
          </Box>
          <Divider/>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '1%'
            }}
          >
            <Box
              sx={{
                height: 474,
                width: '100%'
              }}
            >
              {/* CASH */}
              <Typography
                align="center"
                color="textPrimary"
                variant="h5"
              >
                CASH
              </Typography>
              <DataGrid
                rows={cashTableData}
                columns={columns}
                getRowId={(row) => row.displayId}
                disableSelectionOnClick
                disableColumnMenu
                hideFooter
                localeText={{
                  noRowsLabel: 'No Cash Payments'
                }}
              />
            </Box>
            <Box
              sx={{
                height: 474,
                width: '100%'
              }}
            >
              {/* CARD */}
              <Typography
                align="center"
                color="textPrimary"
                variant="h5"
              >
                CARD
              </Typography>
              <DataGrid
                rows={cardTableData}
                columns={columns}
                getRowId={(row) => row.displayId}
                disableSelectionOnClick
                disableColumnMenu
                hideFooter
                localeText={{
                  noRowsLabel: 'No Card Payments'
                }}
              />
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '2%'
            }}
          >
            <Button
              color="primary"
              variant="contained"
              onClick={props.closeModal}
            >
              Close
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Modal>
  )
};

export default MonthlyCCTable;